import config from 'config';

export const showSmsConsent = (tld) => {
  return config.get('public.brand.smsConsent')?.includes(tld);
};
